export enum RecursosEnum {
  CONFIRMAR_PAGAMENTO = "CONFIRMAR_PAGAMENTO",
  RETORNAR_STATUS = "RETORNAR_STATUS",
  MINHAS_VISTORIAS = "MINHAS_VISTORIAS",
  MAPA_BI = "MAPA_BI",
  AGENDAMENTO_ITINERANTE = "AGENDAMENTO_ITINERANTE",
  DENUNCIAS = "DENUNCIAS",
  DOCUMENTOS = "DOCUMENTOS",
  COMUNICAR_ATRASO = "COMUNICAR_ATRASO",
  COMUNICAR_CHEGADA = "COMUNICAR_CHEGADA",
  REGISTRAR_IMPEDIMENTO = "REGISTRAR_IMPEDIMENTO",
  TREINAMENTOS = "TREINAMENTOS",
}
